import { render } from "./ChevronRight.vue?vue&type=template&id=6df3a67a&scoped=true"
const script = {}

import "./ChevronRight.vue?vue&type=style&index=0&id=6df3a67a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df3a67a"]])

export default __exports__